<template lang="en">
    <div>
		<Loader :show="loading" type="inline"></Loader>

		<div class="filters_listing" v-if="format=='select'">
			<div class="">
				<ul class="clearfix">
					<li v-for="item in list" :key="item.id">
						<h6>{{item.name}}</h6>
						<select name="orderby" class="selectbox" v-model="selected" @change="goTo()" style="max-width: 100%;">
							<option :value="service.slug" v-for="service in item.clinic_services" :key="service.id" >{{service.name}}</option>
						</select>
					</li>
					
				</ul>
			</div>
		</div>


		<ul :style="`column-count: ${rows};`" v-if="format=='list'">
			<li v-for="item in list" :key="item.id" >
				<div class="label"> {{item.name}}</div>
				<div v-for="service in item.clinic_services" :key="service.id" >
					<router-link tag="a" :to="'/clinics/'+service.slug" class="link" >{{service.name}}</router-link>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import Loader from '@/components/Loader'
export default {
	name: 'ExamnsList',
	props: {
		format: {
			default: 'list',
		},
		rows: {
			default: 2,
		},
		filterByCategory: {
			default: null,
		},
	},
	components: {
		Loader,
	},
	data() {
		return {
			selected: null,
			items: [],
			list: [],
			loading: true,
		}
	},
	beforeMount() {
		this.load()
		console.log(this.$route.params.service)
		if (this.$route.params.service) {
			this.selected = this.$route.params.service
		}
	},

	methods: {
		goTo() {
			this.$router.push(`/clinics/${this.selected}`)
		},
		filterList(items) {
			if (this.filterByCategory > 0) {
				items = items.filter((i) => i.id == this.filterByCategory)
			}
			this.$nextTick(() => {
				this.list = items
			})
		},
		load() {
			this.$apollo
				.query({
					query: gql`
						query search($count: Int!) {
							clinic_service_categories(count: $count) {
								data {
									id
									name
									clinic_services {
										id
										name
										slug
									}
								}
							}
						}
					`,
					variables: {
						count: 1000,
					},
					fetchPolicy: 'no-cache',
				})
				.then((data) => {
					this.items = data.data.clinic_service_categories.data
					this.filterList(this.items)
					this.loading = false
				})
				.catch((error) => {
					this.loading = false
					console.log('error al buscar.', error)
				})
		},
	},
}
</script>

<style scoped>
.label {
	font-weight: 500;
}
.link {
	color: #3d3d3d;
	margin-left: 8px;
}
li {
	margin-bottom: 16px;
}
ul {
	column-gap: 20px;
}
</style>
